export default function PlayerSamsungTizen() {
  return (
    <div className="prose">
      <h2>Samsung (Tizen)</h2>
      <p>Deployment and configuration for Samsung Smart Signage (Tizen) devices.</p>
      <ul>
        <li>Supported Tizen versions and models — Todo</li>
        <li>App installation and permissions — Todo</li>
        <li>Device settings, remote management, updates — Todo</li>
      </ul>
    </div>
  )
}
